module.exports = __webpack_public_path__ + "img/decorating.035cdc58.jpg";